import { Card, CardContent, Skeleton, Typography } from '@mui/material'
import React from 'react'
import YouTube from 'react-youtube';

function TutorialCard({ item, isLoading }) {

    const opts = {
        height: '280px',
        width: '100%',
    };
    return (
        <Card sx={{ height: '100%' }}>
            {
                isLoading ?
                    <Skeleton variant="rectangular" sx={{ width: '100%' }} height={280} />

                    : <YouTube loading={isLoading} videoId={item?.id} opts={opts} onReady={(event) => event.target.pauseVideo()} />
            }

            <CardContent sx={{ maxHeight: 400, overflowY: 'auto' }}  >
                <Typography gutterBottom variant="h5" component="div" >
                    {item?.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    {item?.description}
                </Typography>
            </CardContent>
        </Card>
    )
}

export default TutorialCard